import { colors } from "../../../styles/colors"
import { fonts } from "../../../styles/fonts"

const microcycleWrapper = {
    marginTop: 10,
}

const wodOuterWrapper: any = {
    padding: 20,
    background: colors.white,
    boxShadow: "0px 2px 14px 0px rgba(0, 0, 0, 0.1)",
    // minHeight: 1000,
    borderTopRightRadius: 10,
}



export {
    microcycleWrapper,
    wodOuterWrapper
}

